import React from 'react';
import Button from 'kingpin/atoms/Button';
import Inputs from 'components/Inputs';
import useUsersWithAccess from './useUsersWithAccess';
import Row from '../../../../components/Common/Row';
import Form from '../../../../kingpin/forms/Form';
import FormHeader from '../../../../kingpin/forms/FormHeader';
import FormContent from '../../../../kingpin/forms/FormContent';

const ManageUsersContent = ({ close }: { close: () => void }) => {
  const { usersWithAccess, onUserAdded, onUserRemoved, isLoading } =
    useUsersWithAccess();

  return (
    <Form>
      <FormHeader title={'Invite Your Users'} onClose={close} />
      <FormContent>
        <div style={{ marginBottom: 24 }}>
          <Inputs.AddUsersSearch
            selectedUsers={usersWithAccess}
            onUserAdded={onUserAdded}
            isLoading={isLoading}
          />
        </div>
        <Inputs.UsersList
          onUserRemoved={onUserRemoved}
          users={usersWithAccess}
          isLoading={isLoading}
        />
      </FormContent>
      <Row style={{ justifyContent: 'flex-end' }}>
        <Button label="Close" onClick={close} type="Primary" size="Small" />
      </Row>
    </Form>
  );
};

export default ManageUsersContent;
